"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var contexts_1 = require("../../contexts");
var utils_1 = require("../../utils");
var Box_1 = require("../Box");
var FocusedContainer_1 = require("../FocusedContainer");
var Keyboard_1 = require("../Keyboard");
var StyledDrop_1 = require("./StyledDrop");
var DropContainer = /** @class */ (function (_super) {
    tslib_1.__extends(DropContainer, _super);
    function DropContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.dropRef = React.createRef();
        _this.addScrollListener = function () {
            document.addEventListener('scroll', _this.place);
        };
        _this.removeScrollListener = function () {
            document.removeEventListener('scroll', _this.place);
        };
        _this.onClickDocument = function (event) {
            var _a = _this.props, dropTarget = _a.dropTarget, onClickOutside = _a.onClickOutside;
            var dropTargetNode = dropTarget;
            var dropNode = _this.dropRef.current;
            if (onClickOutside &&
                dropNode && // need this for ie11
                !dropTargetNode.contains(event.target) &&
                !dropNode.contains(event.target)) {
                onClickOutside();
            }
        };
        _this.onResize = function () {
            _this.removeScrollListener();
            _this.addScrollListener();
            _this.place();
        };
        _this.place = function () {
            var _a = _this.props, dropTarget = _a.dropTarget, stretch = _a.stretch, theme = _a.theme, topOffsetValue = _a.topOffsetValue;
            var target = dropTarget;
            var container = _this.dropRef.current;
            if (container && target) {
                // clear prior styling
                container.style.left = '';
                container.style.top = '';
                container.style.bottom = '';
                container.style.width = '';
                // get bounds
                var targetRect = utils_1.findVisibleParent(target).getBoundingClientRect();
                // offset width by 0.1 to avoid a bug in ie11 that
                // unnecessarily wraps the text if width is the same
                // NOTE: turned off for now
                container.style.width = stretch ? targetRect.width + 0.1 + "px" : targetRect.width;
                container.style.top = targetRect.bottom -
                    document.body.getBoundingClientRect().top +
                    (topOffsetValue || 0) + "px";
                container.style.left = targetRect.left + "px";
                container.style.maxHeight = theme.global.drop.maxHeight;
            }
        };
        return _this;
    }
    DropContainer.getDerivedStateFromProps = function (nextProps, prevState) {
        // Since the drop background can be different from the current theme context,
        // we update the theme to set the dark background context.
        var propsTheme = nextProps.theme;
        var stateTheme = prevState.theme, priorTheme = prevState.priorTheme;
        var dark = utils_1.backgroundIsDark(propsTheme.global.drop.background, propsTheme);
        if (dark === propsTheme.dark && stateTheme) {
            return { theme: undefined, priorTheme: undefined };
        }
        if (dark !== propsTheme.dark && (!stateTheme || dark !== stateTheme.dark || propsTheme !== priorTheme)) {
            return {
                theme: tslib_1.__assign(tslib_1.__assign({}, propsTheme), { dark: dark, icon: dark ? propsTheme.iconThemes.dark : propsTheme.iconThemes.light }),
                priorTheme: propsTheme
            };
        }
        return null;
    };
    DropContainer.prototype.componentDidMount = function () {
        var restrictFocus = this.props.restrictFocus;
        this.addScrollListener();
        window.addEventListener('resize', this.onResize);
        document.addEventListener('mousedown', this.onClickDocument);
        this.place();
        if (restrictFocus) {
            var dropRef = this.dropRef.current;
            if (dropRef) {
                dropRef.focus();
            }
        }
    };
    DropContainer.prototype.componentDidUpdate = function () {
        this.place();
    };
    DropContainer.prototype.componentWillUnmount = function () {
        this.removeScrollListener();
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('mousedown', this.onClickDocument);
    };
    DropContainer.prototype.render = function () {
        var _a = this.props, children = _a.children, onClickOutside = _a.onClickOutside, onEsc = _a.onEsc, onKeyDown = _a.onKeyDown, restrictFocus = _a.restrictFocus, propsTheme = _a.theme, rest = tslib_1.__rest(_a, ["children", "onClickOutside", "onEsc", "onKeyDown", "restrictFocus", "theme"]);
        var stateTheme = this.state.theme;
        var theme = stateTheme || propsTheme;
        var content = (React.createElement(StyledDrop_1.StyledDrop, tslib_1.__assign({ as: Box_1.Box, elevation: theme.global.drop.shadowSize || 'small', tabIndex: "-1", ref: this.dropRef, theme: theme }, rest), children));
        if (stateTheme) {
            if (stateTheme.dark !== propsTheme.dark && stateTheme.icon) {
                content = (React.createElement(React.Fragment, null,
                    stateTheme.icon,
                    content)); // Todo UPDATE
            }
            content = React.createElement(contexts_1.ThemeContext.Provider, { value: stateTheme }, content);
        }
        content = (React.createElement(Keyboard_1.Keyboard, { onEsc: onEsc, onKeyDown: onKeyDown, target: "document" }, content));
        if (restrictFocus) {
            content = React.createElement(FocusedContainer_1.FocusedContainer, null, content);
        }
        return content;
    };
    DropContainer.defaultProps = {
        stretch: 'width'
    };
    return DropContainer;
}(React.PureComponent));
exports.DropContainer = DropContainer;
//# sourceMappingURL=DropContainer.js.map